"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var checkIsPhoneNumber_1 = __importDefault(require("../utils/checkIsPhoneNumber"));
var form_1 = require("../context/form");
var useForm = function () {
    var _a = (0, form_1.useFormContext)(), name = _a.name, phoneOrEmail = _a.phoneOrEmail, comment = _a.comment, files = _a.files;
    var form = (0, react_1.useMemo)(function () { return (__assign(__assign(__assign(__assign(__assign({}, name.trim() && { name: name.trim() }), (0, checkIsPhoneNumber_1.default)(phoneOrEmail) && { phone: phoneOrEmail.trim() }), !(0, checkIsPhoneNumber_1.default)(phoneOrEmail) && { email: phoneOrEmail.trim() }), { comment: comment.trim() }), !!files && { files: files })); }, [
        name,
        phoneOrEmail,
        comment,
        files
    ]);
    return form;
};
exports.default = useForm;
